import react from 'react';
import styled from "styled-components";
import React from 'react';
import HeroImg from "../Blogssample/heroimgblog/agri.jpg";
import * as ROUTES from "../../Constants/routes";
import { Link } from 'react-router-dom';

const Main = styled.div`
  max-width: 320px;
  margin: 0 auto;
  @media ${(props) => props.theme.MediaQueries.m.query} {
    max-width: 720px;
  }
  @media ${(props) => props.theme.MediaQueries.l.query} {
    max-width: 1200px;
  }
`;

const Header = styled.h1`
  font-family: ${(props) => props.theme.Fonts.Josefin};
  font-weight: 600;
  color: ${(props) => props.theme.Colors.Header};
  margin-bottom: 20px;
  @media ${(props) => props.theme.MediaQueries.m.query} {
    font-size: 70px;
  }
  @media ${(props) => props.theme.MediaQueries.l.query} {
    font-size: 50px;
  }
`;

const HeroDiv = styled.div`
  max-width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  height: 50vh;
  justify-content:center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  text-align: center;
`;

const Blogging = styled.div`
font-size: 18px;
padding:15px;
text-align:justify;
border-radius:25px;
font-family: ${(props) => props.theme.Fonts.Josefin};
background-color: rgba(255, 255, 255, 0.7);
@media ${(props) => props.theme.MediaQueries.m.query} {
    margin:45px;
    font-size: 25px;
    padding:40px;
  }
  @media ${(props) => props.theme.MediaQueries.l.query} {
  margin:70px;
  font-size: 25px;
  padding:60px;
  }
`;
const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const BackButton = styled(Link)`
  text-decoration: none;
`;

const BackButtonStyled = styled.button`
  background-color: #fff;
  color: #333; 
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ddd; 
  }
`;
const BLOG_EIGHT = () => {
    return (
        <>
        <HeroDiv
            style={{
             backgroundImage: ` linear-gradient(rgba(0, 0, 0, 0.7),rgba(0, 0, 0, 0.7)) , url(${HeroImg})`,
             }}
          >
            <Header>The Power of Regenerative Agriculture in Restoring our Environment</Header>
          </HeroDiv>
            <Main>
            <Blogging>
              <p>
              Introduction<br/><br/>
              In recent years, there has been a growing concern about the state of our environment and the urgent need for sustainable solutions. One such solution gaining momentum is regenerative agriculture. This innovative farming practice not only addresses the challenges of food production but also holds the potential to mitigate climate change, restore biodiversity, and improve soil health. In this blog, we will explore the concept of regenerative agriculture and its transformative impact on our environment.<br/><br/>Understanding Regenerative Agriculture<br/>
              <br/>Regenerative agriculture is a holistic approach to farming that focuses on improving and restoring natural ecosystems. Unlike conventional farming practices that often deplete soil health and rely heavily on synthetic inputs, regenerative agriculture aims to work with nature rather than against it. It emphasizes practices such as cover cropping, crop rotation, minimal tillage, and the integration of livestock to restore soil fertility, biodiversity, and ecosystem services.<br/><br/>Benefits for Soil Health<br/><br/>One of the key components of regenerative agriculture is soil health. Healthy soils act as a carbon sink, storing atmospheric carbon dioxide and reducing greenhouse gas emissions. By adopting regenerative practices, farmers can increase organic matter content in the soil, enhance water retention capacity, and improve nutrient cycling. This not only leads to more resilient and productive farmland but also reduces the need for synthetic fertilizers and pesticides, thus decreasing the associated environmental risks.
              <br/><br/>Climate Change Mitigation<br/><br/>Regenerative agriculture has the potential to significantly contribute to global climate change mitigation efforts. Through carbon sequestration in the soil, this practice helps offset greenhouse gas emissions. According to a study published in the journal Nature, transitioning to regenerative agriculture practices could potentially sequester up to 9.66 gigatons of CO2 annually, equivalent to removing nearly 7.5 billion passenger vehicles from the road.<br/><br/>Biodiversity Conservation<br/><br/>Industrial agriculture has been a major driver of biodiversity loss, with monocultures and excessive pesticide use causing habitat destruction and the decline of pollinators. Regenerative agriculture, on the other hand, promotes diverse and resilient ecosystems. By incorporating cover crops, hedgerows, and rotational grazing, it creates habitats for beneficial insects, birds, and other wildlife. This not only supports biodiversity but also helps in natural pest control, reducing the need for chemical interventions.<br/><br/>Water Management and Conservation<br/><br/>Water scarcity is a pressing concern in many regions worldwide. Regenerative agriculture practices help improve water management and conservation. By enhancing soil structure and organic matter content, the soil's water-holding capacity is increased, reducing runoff and erosion. This helps conserve water resources and improves watershed health. Additionally, regenerative practices reduce the need for irrigation, thus decreasing the strain on freshwater sources.<br/><br/>Conclusion<br/><br/>Regenerative agriculture offers a promising solution to the environmental challenges we face today. By adopting regenerative practices, farmers can play a pivotal role in restoring soil health, mitigating climate change, conserving biodiversity, and improving water management. However, widespread adoption of regenerative agriculture requires supportive policies, education, and incentives. It is crucial for governments, organizations, and individuals to recognize the potential of regenerative agriculture and work together to create a sustainable and resilient future for our planet.
              </p>
             </Blogging>
             <BackButtonWrapper>
              <BackButton to={ROUTES.BLOGS}>
                <BackButtonStyled>Back</BackButtonStyled>
              </BackButton>
            </BackButtonWrapper>
            </Main>
        </>
    );
};
 
export default BLOG_EIGHT;
